export default __webpack_public_path__ + "static/media/icon_email.0e31dfe5.svg";